// extracted by mini-css-extract-plugin
export default {"titleWrapper":"_9b824c9e40fe5f46","togglerWrapper":"_16e76dbcee8b27b0","toggler":"e317fad520173d51","text":"_2e6ecf14202eca9e","textSkipped":"_6bc2ced311619938"};